import React from 'react';
import Logo from "../../../../assets/imgs/swirepay-logo.svg";

type Props = {};

const LogoComp = (props: Props) => {
  return (
    <div className="row no-gutters mb-4">
      <div className="col text-center">
        <div>
          <span className="text-muted"><span className="pr-2">Powered by</span><span><img src={Logo} height="45rem" style={{ marginBottom: "-10px" }} alt="" /></span></span>
        </div>
      </div>
    </div>
  );
};

export default LogoComp;
